class ReviewSlider extends HTMLElement {
    constructor() {
      super();
      this.splideOptions = {
        gap: 0,
        type: 'loop',
        pagination: false,
        dragMinThreshold: {
          mouse: 50,
          touch: 110,
        },
        breakpoints : {
          990: {
            width: '550px',
            pagination: true,
            flickMaxPages: 1,
          }
        }
      }
  
      this.featuresModule = new Splide('.js-review-slider', this.splideOptions);
      this.featuresModule.mount();
    }
  }
  
  customElements.define('review-slider', ReviewSlider);